import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlockDeviceForm } from '../block-device-modal-form/useBlockDeviceForm.vm';

export interface UseBlockDeviceModalReturn {
  readonly form: ReturnType<typeof useBlockDeviceForm>;
}

export function useBlockDeviceModalVm(): UseBlockDeviceModalReturn {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.LOGICAL_DEVICE]);
  const defaultValues = useMemo(
    () => ({
      title: t('blockDeviceModal.defaultFieldValues.title', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE }),
      text: t('blockDeviceModal.defaultFieldValues.text', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE }),
    }),
    [t],
  );
  const form = useBlockDeviceForm(defaultValues);

  return {
    form,
  };
}
